import { createContext, useReducer } from 'react'

export type OrderContextActions = 'REPLACE' | 'UPDATE_REVIEW'

// Reducer
const OrderDetailReducer = (
  state: Types.OrderShopHelp,
  action: { type: OrderContextActions; payload: any }
) => {
  let result = { ...state }
  switch (action.type) {
    case 'REPLACE':
      result = { ...action.payload }
      break
    case 'UPDATE_REVIEW':
      result = { ...state, review: { ...action.payload } }
      break
  }
  return result
}

// Context
const OrderContext = createContext<{
  orderDetail: Types.OrderShopHelp
  dispatchOrder: React.Dispatch<any>
}>({
  orderDetail: {} as Types.OrderShopHelp,
  dispatchOrder: () => null
})

const OrderProvider: React.FC = ({ children }) => {
  const [orderDetail, dispatchOrder] = useReducer(OrderDetailReducer, {})

  return (
    <OrderContext.Provider value={{ orderDetail, dispatchOrder: dispatchOrder }}>
      {children}
    </OrderContext.Provider>
  )
}

export { OrderContext, OrderProvider }
